/* Component in the Callsheet to display the Callsheet crew 
   items passed down from the Callsheet
 * Contains the CrewCallsAdd2 component */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import CrewCallsAdd2 from './CrewCallsAdd2';

const CrewCallsPageAdd2 = ({crewcalls, handleMount}) => {
  const results = (crewcalls?.results ?? []).filter(Boolean);

  return (
    <div className='mt-3'>
        {/* titles */}
        <div >
        <Row>
        <Col lg={6} className='d-none d-lg-block' >
        <Row style={{ textTransform: 'uppercase' }} 
        className={`text-center mx-0 ${styles.TitleBox}`} >
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={5}>
                <p className='mb-0'>Position</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={4}>
                <p className='mb-0 pl-2'>Name</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2}>
                <p className='mb-0'>Call</p>
            </Col>
            <Col className={`text-center mx-0 px-0 ${styles.TitleBox2}`} xs={1}>
                <p className='mb-0'>Edit</p>
            </Col>
        </Row>
        </Col>
        <Col sm={12} lg={6} className='d-none d-sm-block'>
        <Row style={{ textTransform: 'uppercase' }} 
        className={`text-center mx-0  ${styles.TitleBox}`} >
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={5}>
                <p className='mb-0'>Position</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={4}>
                <p className='mb-0 pl-2'>Name</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={2}>
                <p className='mb-0'>Call</p>
            </Col>
            <Col className={`text-center mx-0 px-0 ${styles.TitleBox2}`} xs={1}>
                <p className='mb-0'>Edit</p>
            </Col>
        </Row>
        </Col>
        <Col sm={12} lg={6} className='d-block d-sm-none'>
        <Row style={{ textTransform: 'uppercase' }} 
        className={`text-center mx-0  ${styles.TitleBox}`} >
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={8}>
                <p className='mb-0'>Position/Name</p>
            </Col>
            <Col className={`mx-0 px-0 ${styles.TitleBox2}`} xs={3}>
                <p className='mb-0'>Call</p>
            </Col>
            <Col className={`text-center mx-0 px-0 ${styles.TitleBox2}`} xs={1}>
                <p className='mb-0'>Edit</p>
            </Col>
        </Row>
        </Col>
        </Row>
        </div>
        {/* calls */}
        <Row>
            {results.length ? (
                results.map((crew, index) => (
            <Col xs={12} lg={6} className='' key={crew?.id ?? `crew-${index}`} >
                    <CrewCallsAdd2
                    // style={{ backgroundColor: (index % 3 === 0) 
                    //     ? '#f6fffe' : (index % 2 === 0) ? 
                    //     'rgb(246 254 245)' : 'rgb(252 246 251)' }}
                        {...crew}
                        handleMount={handleMount}
                        crew={crew} />
            </Col>
                ))) : ("")}
        </Row>
    </div>
  )
}

export default CrewCallsPageAdd2